//Facilities section
(function($) {
	"use strict";
	$('.section-facilities').each(function () {
		$(this).find('a.js-facility-link').on('click', function(event){

			//hide all facilities, then find active facility and show it
			$(this)
				.closest('.section-facilities')
				.find('.js-facility-description')
				.addClass('js-hidden')
				.filter('[id=' + $(this).attr('href').substring(1) + ']')
				.removeClass('js-hidden');


			//If on mobile, show the description
			$(this)
				.siblings('.js-facility-description--mobile')
				.toggleClass('js-shown')

			//prevent jumping to the element, as it's just here onb the right already.
			event.preventDefault();
		});
	});

})(jQuery);